import {AppLanguage} from '@/logged/common/composables';
import {I18nService} from '@malt/vue3-i18n';
import {computed} from 'vue';
import type {NewUserOnboardingCard} from '../onboarding-new-user.types';

export function useOnboardingSteps() {
    const onboardingSteps = computed((): NewUserOnboardingCard[] => [
        {
            id: 'find-freelancer',
            title: I18nService.msg('navbar.onboarding.dialog.steps.find.freelancer.title'),
            icon: 'aside/find-free',
            illustrations: {
                [AppLanguage.FR]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/FR/find-freelancer.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/FR/mobile/mobile-find-freelancer.png',
                },
                [AppLanguage.EN]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/EN/find-freelancer.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/EN/mobile/mobile-find-freelancer.png',
                },
                [AppLanguage.ES]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/ES/find-freelancer.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/ES/mobile/mobile-find-freelancer.png',
                },
                [AppLanguage.DE]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/find-freelancer.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-find-freelancer.png',
                },
                [AppLanguage.NL]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/find-freelancer.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-find-freelancer.png',
                },
            },
            description: I18nService.msg('navbar.onboarding.dialog.steps.find.freelancer.description'),
        },
        {
            id: 'process-applications',
            title: I18nService.msg('navbar.onboarding.dialog.steps.process.applications.title'),
            icon: 'aside/process-applications',
            illustrations: {
                [AppLanguage.FR]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/FR/process-applications.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/FR/mobile/mobile-process-applications.png',
                },
                [AppLanguage.EN]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/EN/process-applications.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/EN/mobile/mobile-process-applications.png',
                },
                [AppLanguage.ES]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/ES/process-applications.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/ES/mobile/mobile-process-applications.png',
                },
                [AppLanguage.DE]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/process-applications.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-process-applications.png',
                },
                [AppLanguage.NL]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/process-applications.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-process-applications.png',
                },
            },
            description: I18nService.msg('navbar.onboarding.dialog.steps.process.applications.description'),
        },
        {
            id: 'manage-projects',
            title: I18nService.msg('navbar.onboarding.dialog.steps.manage.projects.title'),
            icon: 'aside/manage-projects',
            illustrations: {
                [AppLanguage.FR]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/FR/manage-projects.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/FR/mobile/mobile-manage-projects.png',
                },
                [AppLanguage.EN]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/EN/manage-projects.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/EN/mobile/mobile-manage-projects.png',
                },
                [AppLanguage.ES]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/ES/manage-projects.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/ES/mobile/mobile-manage-projects.png',
                },
                [AppLanguage.DE]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/manage-projects.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-manage-projects.png',
                },
                [AppLanguage.NL]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/manage-projects.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-manage-projects.png',
                },
            },
            description: I18nService.msg('navbar.onboarding.dialog.steps.manage.projects.description'),
        },
        {
            id: 'reporting',
            title: I18nService.msg('navbar.onboarding.dialog.steps.reporting.title'),
            icon: 'aside/analytics',
            illustrations: {
                [AppLanguage.FR]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/FR/reporting.svg',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/FR/mobile/mobile-reporting.png',
                },
                [AppLanguage.EN]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/EN/reporting.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/EN/mobile/mobile-reporting.png',
                },
                [AppLanguage.ES]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/ES/reporting.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/ES/mobile/mobile-reporting.png',
                },
                [AppLanguage.DE]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/reporting.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-reporting.png',
                },
                [AppLanguage.NL]: {
                    desktop: 'https://dam.malt.com/navbar/onboarding/new-client/DE/reporting.png',
                    mobile: 'https://dam.malt.com/navbar/onboarding/new-client/DE/mobile/mobile-reporting.png',
                },
            },
            description: I18nService.msg('navbar.onboarding.dialog.steps.reporting.description'),
        },
    ]);

    return onboardingSteps;
}
